module.exports = __webpack_public_path__ + "static/img/ckBanner.674e2fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/ckBanner.jpg
// module id = COBE
// module chunks = 1